import { View } from '@react-pdf/renderer';
import React from 'react';

function Container(props) {
  const { children, justify = 'space-around', wrap = false } = props;
  const perStyles = {};

  if (justify) {
    perStyles.justifyContent = justify;
  }
  if (wrap) {
    perStyles.flexWrap = 'wrap';
  }

  return (
    <View
      style={{
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'space-around',
        ...perStyles,
      }}
    >
      {children}
    </View>
  );
}
export default Container;
